/* eslint-disable react-refresh/only-export-components */
import { IAttendanceCodesAndShifts } from '@/types/type'
import { createContext, ReactNode, useContext, useMemo, useState } from 'react'

export interface IAppContext {
  operationAndSupervisorNotification: boolean
  setOperationAndSupervisorNotification: React.Dispatch<React.SetStateAction<boolean>>
  definitionsAndAbbreviationsList: IAttendanceCodesAndShifts | null
  setDefinitionsAndAbbreviationsList: React.Dispatch<React.SetStateAction<IAttendanceCodesAndShifts | null>>
  loginEmail: string
  setLoginEmail: React.Dispatch<React.SetStateAction<string>>
}

const AppContext = createContext<IAppContext | null>(null)

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [operationAndSupervisorNotification, setOperationAndSupervisorNotification] = useState(false)
  const [definitionsAndAbbreviationsList, setDefinitionsAndAbbreviationsList] = useState<IAttendanceCodesAndShifts | null>(null);
  const [loginEmail, setLoginEmail] = useState<string>('');

  const value = useMemo(
    () => ({
      operationAndSupervisorNotification,
      setOperationAndSupervisorNotification,
      definitionsAndAbbreviationsList,
      setDefinitionsAndAbbreviationsList,
      loginEmail,
      setLoginEmail,
    }), [operationAndSupervisorNotification, definitionsAndAbbreviationsList, loginEmail])
  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  )
}

export function useApp() {
  const context = useContext(AppContext)
  if (!context) {
    throw new Error('useApp must be used within an AppProvider')
  }
  return context
}